import { db } from './firebase';
import { collection, getDocs, addDoc, deleteDoc, doc, query, orderBy, limit, serverTimestamp } from 'firebase/firestore';

const COL = 'app_updates';
const LS_KEY = 'plhouse.app.version';

export async function fetchLatestUpdate() {
  const q = query(collection(db, COL), orderBy('createdAt', 'desc'), limit(1));
  const snap = await getDocs(q);
  if (snap.empty) return null;
  return { id: snap.docs[0].id, ...snap.docs[0].data() };
}

export async function fetchAllUpdates() {
  const q = query(collection(db, COL), orderBy('createdAt', 'desc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function addUpdate({ version, content }) {
  return await addDoc(collection(db, COL), {
    version,
    content,
    createdAt: serverTimestamp(),
  });
}

export async function deleteUpdate(id) {
  await deleteDoc(doc(db, COL, id));
}

export function isVersionNewer(serverVer, localVer) {
  if (!serverVer || !localVer) return true;
  const s = serverVer.split('.').map(Number);
  const l = localVer.split('.').map(Number);
  for (let i = 0; i < Math.max(s.length, l.length); i++) {
    const sv = s[i] || 0;
    const lv = l[i] || 0;
    if (sv > lv) return true;
    if (sv < lv) return false;
  }
  return false;
}

export async function checkAppUpdate({ onUpdate }) {
  try {
    const latest = await fetchLatestUpdate();
    if (!latest || !latest.version) return;

    const localVer = localStorage.getItem(LS_KEY);

    if (!localVer) {
      // 첫 방문: 기준값만 저장
      localStorage.setItem(LS_KEY, latest.version);
      return;
    }

    if (isVersionNewer(latest.version, localVer)) {
      localStorage.setItem(LS_KEY, latest.version);
      if (onUpdate) onUpdate(latest);
      setTimeout(() => {
        const base = window.location.href.split('?')[0].split('#')[0];
        const hash = window.location.hash || '';
        window.location.replace(`${base}?v=${Date.now()}${hash}`);
      }, 1500);
    }
  } catch (e) {
    console.error('버전 체크 실패:', e);
  }
}
